export default "__VITE_ASSET__DSmyG1sA__"